// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conn-form-raw-sql-level__control {
  display: flex;
  flex-direction: column;
  margin-top: 4px;
  row-gap: 16px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/connections/components/ConnectorForm/preparedRows/RawSQLLevelRow/RawSQLLevelRow.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;AAAR","sourcesContent":[".conn-form-raw-sql-level__control {\n  display: flex;\n  flex-direction: column;\n  margin-top: 4px;\n  row-gap: 16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
